import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { Divider } from '../../components/divider'
import ShareFeedback from './ShareFeedback'
import { routePaths as routes } from '../../utilities/routePaths'
import { withRouter } from 'react-router-dom'
import css from './confirmation.module.css'

export const OpDivConfirmation = ({ history, showFeedback }) => (
  <main data-testid="complaint-confirmation">
    <h1>Confirmation</h1>
    <p>You have successfully submitted your complaint.</p>
    <p>We will review your complaint for relevance and completeness.</p>
    <Button
      variation="secondary"
      data-testid="confirm-complaint"
      onClick={() => history.push(routes.opdiv.form)}
      className={css.buttonSpacing}
    >
      Submit another complaint
    </Button>
    {showFeedback ? (
      <React.Fragment>
        <Divider />
        <ShareFeedback />
      </React.Fragment>
    ) : (
      ''
    )}
  </main>
)

export default withRouter(OpDivConfirmation)
